import type { FunctionComponent } from 'react';

export const TrashCanIcon: FunctionComponent = () => {
    return (
        // biome-ignore lint/a11y/noSvgWithoutTitle: suppressed due to migration
        <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M4 12.6667C4 13.4 4.6 14 5.33333 14H10.6667C11.4 14 12 13.4 12 12.6667V6C12 5.26667 11.4 4.66667 10.6667 4.66667H5.33333C4.6 4.66667 4 5.26667 4 6V12.6667ZM6 6H10C10.3667 6 10.6667 6.3 10.6667 6.66667V12C10.6667 12.3667 10.3667 12.6667 10 12.6667H6C5.63333 12.6667 5.33333 12.3667 5.33333 12V6.66667C5.33333 6.3 5.63333 6 6 6ZM9.66667 2.66667L9.19333 2.19333C9.07333 2.07333 8.9 2 8.72667 2H7.27333C7.1 2 6.92667 2.07333 6.80667 2.19333L6.33333 2.66667H5.33333C4.96667 2.66667 4.66667 2.96667 4.66667 3.33333C4.66667 3.7 4.96667 4 5.33333 4H10.6667C11.0333 4 11.3333 3.7 11.3333 3.33333C11.3333 2.96667 11.0333 2.66667 10.6667 2.66667H9.66667Z"
                fill="#6E6E6C"
            />
        </svg>
    );
};
